import { CreditCardForm } from '@wix/payments-cc-form/dist/lib/CreditCardForm';
import React from 'react';
import { DeviceType } from '../../../../types/DeviceType';
import { Theme } from '../../../../types/Theme';
import { DH } from '../../../../utils/DataHook';
import { Loader } from '../../../Loader';
import { PaymentMethodLayout } from '../PaymentMethodLayout';
import { CommonMethodProps } from '../types';
import {
  CardArea,
  CardFormContainer,
  ErrorMessage,
  InstallmentsWrapper,
  SaveCardCheckboxWrapper,
} from './elements';
import { Installments } from './Installments';
import { SaveCardCheckbox } from './SaveCardCheckbox';

export interface CreditCardViewProps extends CommonMethodProps {
  isSaveCardAvailable: boolean;
  installments?: {
    minInstallments: number;
    maxInstallments: number;
  };
  isSavedCard: boolean;
  isCardFormCollapsed: boolean;
  isLoading: boolean;
  isError?: boolean;
  tokenizeMode?: boolean;
  deviceType: DeviceType;
  ccFormProps: React.ComponentProps<typeof CreditCardForm>;
}

export class CreditCardView extends React.Component<CreditCardViewProps> {
  get shouldRenderInstallments(): boolean {
    const { installments, tokenizeMode } = this.props;

    return (
      !tokenizeMode &&
      installments &&
      installments.minInstallments &&
      installments.maxInstallments &&
      installments.maxInstallments - installments.minInstallments >= 0
    );
  }

  renderSaveCardCheckbox() {
    return (
      <SaveCardCheckboxWrapper>
        <SaveCardCheckbox
          deviceType={this.props.deviceType || this.props.deviceType}
        />
      </SaveCardCheckboxWrapper>
    );
  }

  renderInstallments() {
    const { installments } = this.props;

    return (
      <InstallmentsWrapper
        isModalTheme={this.props.theme === Theme.modal}
        isCardFormCollapsed={this.props.isCardFormCollapsed}
      >
        <Installments
          installments={installments}
          deviceType={this.props.deviceType}
          theme={this.props.theme}
        />
      </InstallmentsWrapper>
    );
  }

  renderCreditCardForm() {
    return (
      <CardArea isSavedCard={this.props.isSavedCard}>
        <CardFormContainer isCollapsed={this.props.isCardFormCollapsed}>
          <CreditCardForm {...this.props.ccFormProps} />
        </CardFormContainer>
        {!this.props.tokenizeMode &&
          this.props.isSaveCardAvailable &&
          this.renderSaveCardCheckbox()}
        {this.shouldRenderInstallments && this.renderInstallments()}
      </CardArea>
    );
  }

  render() {
    const shouldRenderLoader: boolean =
      this.props.isLoading && !this.props.isError;

    return (
      <PaymentMethodLayout
        dataHook={DH.PaymentMethod.CreditCard.Container}
        noPadding={!this.props.isError}
        theme={this.props.theme}
      >
        {this.props.isError ? (
          <ErrorMessage isSavedCard={this.props.isSavedCard} />
        ) : (
          this.renderCreditCardForm()
        )}
        {shouldRenderLoader && <Loader />}
      </PaymentMethodLayout>
    );
  }
}
